import getCustomResourceFiles, {
	IDownloadCustomResourcesParams,
} from '@/lib/getCustomResourceFiles'
import JsFileDownloader from 'js-file-downloader'
import {
	IGtmTrackingResources,
	trackUniversalResourceEvent,
	transformGtmTrackingResourcesForTracking,
} from './gtmTracking'

export async function downloadCustomResource(
	param: IDownloadCustomResourcesParams,
	abortSignal?: AbortSignal,
	pageUrl?: string,
	pageType?: string,
	syllabusContext?: {
		codename?: string
		isLifeSkills?: boolean
		isMainstream?: boolean
	},
	gtmTrackingFiles?: IGtmTrackingResources[],
): Promise<[boolean, string]> {
	const { ok, output, message } = await getCustomResourceFiles(
		param,
		abortSignal,
	)

	if (ok && output && output.code === 200) {
		// Track the download event using GTM tracking utility
		try {
			// Get actual file size if API returns 0
			let zipFileSize = output.size
			if (!zipFileSize && output.path) {
				const { downloadFileWithSize } = await import(
					'./getFilesizeFormatter'
				)
				zipFileSize = await downloadFileWithSize(
					output.path,
					output.name,
				)
			} else {
				// Use JsFileDownloader as fallback when we have file size from API
				await new JsFileDownloader({
					url: output.path,
					filename: output.name,
					autoStart: true,
					forceDesktopMode: true,
				})
			}

			// Transform gtmTrackingFiles to the format expected by trackUniversalResourceEvent
			const resourcesToTrack = gtmTrackingFiles
				? transformGtmTrackingResourcesForTracking(gtmTrackingFiles)
				: []

			// Use the transformed resources array for tracking
			trackUniversalResourceEvent(
				true,
				resourcesToTrack,
				pageType,
				pageUrl,
				undefined,
				syllabusContext,
				zipFileSize, // Pass the actual zip file size for the outer file_size in datalayer
			)
		} catch (error) {
			console.warn(
				'GTM tracking failed for custom resource download:',
				error,
			)
		}

		return [ok, '']
	}
	return [false, (output?.message || message) ?? 'No resource found']
}
